import React, { useEffect, useState, useCallback, useRef } from 'react';
import { ActionType } from '../../stores/action-types';
import { useDispatch } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { connect } from 'react-redux';
import { ISystem } from '../../helpers/interfaces';

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
const checkedIcon = <CheckBoxIcon fontSize='small' />;

interface SystemSearchBarProps {
    systems: ISystem[];
    isSystemSearchBarVisible: boolean;
    dashboardFilteredSystemNamesForGroup: string[];
}

const SystemSearchBar = ({
                             systems,
                             isSystemSearchBarVisible,
                             dashboardFilteredSystemNamesForGroup
                         }: SystemSearchBarProps) => {
    const systemNames = [...systems].map((system: ISystem) => system.name);
    const systemOptions = systemNames.sort();
    const ref = useRef();
    const dispatch = useDispatch();

    const [pickedSystemNames, setPickedSystemNames] = useState([]);

    const filterSystems = useCallback((pickedNames) => {
        dispatch({ type: ActionType.SHOW_FILTERED_SYSTEM_NAMES_FOR_GROUP, payload: pickedNames });
    }, [pickedSystemNames]);

    useEffect(() => {
        ref.current.focus();
    }, [isSystemSearchBarVisible]);

    const handleSelectChange = (e, pickedNames) => {
        setPickedSystemNames(pickedNames);
        filterSystems(pickedNames);
    };
    const [inputValue, setInputValue] = useState("");
    return (
        <Autocomplete
            multiple
            id='checkboxes-systems'
            options={systemOptions}
            value={pickedSystemNames}
            inputValue={inputValue}
            disableCloseOnSelect
            getOptionLabel={(system) => system}
            renderOption={(system, { selected }) => (
                <>
                    <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8, color: 'gray' }} checked={selected} />
                    {system}
                </>
            )}
            style={{
                backgroundColor: 'rgba(250,250,250,0.75)',
                transition: '0.3s',
                margin: isSystemSearchBarVisible ? '0 15px 15px 15px' : '0 15px',
                height: isSystemSearchBarVisible ? 'auto' : '0',
                opacity: isSystemSearchBarVisible ? '1' : '0',
            }}
            renderInput={(systems) =>
                <TextField
                    {...systems}
                    variant='outlined'
                    label='Systems search bar'
                    placeholder='Favorites'
                    inputRef={ref}
                    onChange={(e) => setInputValue(e.target.value)}
                />
            }
            onChange={(e, pickedSystems) => handleSelectChange(e, pickedSystems)}
            fullWidth
            disabled={!isSystemSearchBarVisible}
            clearOnBlur={true}
        />
    );
};

const mapStateToProps = (state) => {
    return {
        isSystemSearchBarVisible: state.account.isAccountSystemSearchBarVisible,
    };
};

export default connect(mapStateToProps, null)(SystemSearchBar);
